const CardsDisplayType = Object.freeze({
	TILE: "tile",
	LIST: "list",
});
export default CardsDisplayType;